export default {
    en: {
        id: 'exercise3',
        answers: [
            {
                title: `<div class="box-title">Risk that PCI work on data transfer will be delayed by efforts to align to 4 planned implementations</div>`,
                answer: 1,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Transferred business activities up</div>
                <div>
                  - With minimum duplication of
                </div>
                <div>
                  - With minimum delay
                </div>`,
                answer: 2,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Real possibility of duplicating</div>`,
                answer: 3,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Plan the activities for the five projects together</div>`,
                answer: 4,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Several SWCP conversion programs are  being implemented at the same time, which also require data conversion work</div>
                    <div>
                      - Global Manufacturing SAP
                    </div>
                    <div>
                      - Engineering
                    </div>
                    <div>
                      - IT infrastructure development
                    </div>
                    <div>
                      - eProcurement
                    </div>`,
                answer: 5,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Our data transfer activities must align with theirs</div>
                    <div>
                      - Must coincide, where feasible, with their transfer and rollout tasks
                    </div>`,
                answer: 6,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Hire an additional manager to coordinate activities with the Site Closure Program Manager, the mana gers at the receiving sites, and the various implementation teams</div>`,
                answer: 7,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Align the activities of the 5 projects</div>
                        <div>
                          - 5 projects
                        </div>
                        <div>
                          - 5 sets of managers
                        </div>
                        <div>
                          - 5 implementation teams
                        </div>
                        <div>
                          - 5 Local Responsible People
                        </div>`,
                answer: 8,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Still have IS systems up and running before transfer of business operations</div> `,
                answer: 9,
                hasArrow: true
            }
        ],
        image: 'section-5d-5.png'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5d/writingProposalsPlans/i18n/exercise3.js